<template>
	<div>
		<loading v-if="!loaded" />
		<el-tabs v-model="tabName" v-if="loaded">
			<el-tab-pane label="All clients" name="first"></el-tab-pane>
			<el-tab-pane label="New client" name="second"></el-tab-pane>
		</el-tabs>
		<div v-if="tabName == 'first' && loaded">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-40">
					<md-field>
						<label>Search client by name, phone or ID</label>
						<md-input v-model="search.text" type="text" @keyup.enter="searchHandler()"></md-input>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-30">
					<md-field>
						<label>Gender</label>
						<md-select placeholder="Gender (All)" v-model="search.gender">
							<md-option value="">All</md-option>
							<md-option value="f">Female</md-option>
							<md-option value="m">Male</md-option>
							<md-option value="o">Other</md-option>
						</md-select>
					</md-field>
				</div>
				<div class="md-layout-item md-size-30">
					<md-button class="md-raised md-primary" @click="searchHandler()" style="width: 100%">Search
					</md-button>
				</div>
			</div>

			<md-table v-if="clientList.length > 0">
				<md-table-row>
					<md-table-head>N.o</md-table-head>
					<md-table-head>Client ID</md-table-head>
					<md-table-head>Name</md-table-head>
					<md-table-head>Gender</md-table-head>
					<md-table-head>Phone</md-table-head>
					<md-table-head>Total Loan Amount</md-table-head>
					<md-table-head>Created Date</md-table-head>
					<md-table-head>Action</md-table-head>
				</md-table-row>

				<md-table-row v-for="(client, index) in clientList">
					<md-table-cell>{{ index + 1 }}</md-table-cell>
					<md-table-cell>
						<img src="@/assets/img/default-member.png" style="width: 34px; margin-right:5px">
						{{ client.hash_id }}</md-table-cell>
					<md-table-cell>{{ client.name }}<br>{{client.name_khmer}}</md-table-cell>
					<md-table-cell>{{ config.getGender(client.gender) }}</md-table-cell>
					<md-table-cell>{{ client.phone }}</md-table-cell>
					<md-table-cell><b>{{config.moneylify(client.total_loan_amount)}} ({{client.total_loan}})</b></md-table-cell>
					<md-table-cell>{{ config.datelify(client.created_date) }}</md-table-cell>
					<md-table-cell>
						<router-link :to="'/clients/detail/' + client.hash_id">
							<md-button class="md-just-icon md-simple md-success">
								<md-icon>visibility</md-icon>
								<md-tooltip md-direction="top">View this client</md-tooltip>
							</md-button>
						</router-link>
						<!-- <md-button class="md-just-icon md-simple md-info">
							<md-icon>edit</md-icon>
							<md-tooltip md-direction="top">Edit client information</md-tooltip>
						</md-button>

						<md-button class="md-just-icon md-simple md-danger">
							<md-icon>close</md-icon>
							<md-tooltip md-direction="top">Delete this client</md-tooltip>
						</md-button> -->
					</md-table-cell>
				</md-table-row>
			</md-table>

			<h4 class="text-center" v-if="clientList.length == 0 && loadMore == true">No client data.</h4>
			<!-- <div class="places-buttons text-center" v-if="loadMoreCompanyButton" >
				<md-button class="md-primary" @click="getCompany(companyList.length, false)">បង្ហាញបន្ថែម</md-button>
			</div> -->
		</div>



		<div v-if="tabName == 'second'">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-50">
					<div class="md-layout-item md-small-size-100 md-size-100">
						<h3>Client Information</h3>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100 text-right">
						<span class="late">* required</span>
					</div>
					<div class="md-layout">
						<div class="md-layout-item md-small-size-100 md-size-50">
							<md-field>
								<label>Client Name *</label>
								<md-input type="text" v-model="client.name"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-50">
							<md-field>
								<label>Client Khmer Name *</label>
								<md-input type="text" v-model="client.name_khmer"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-50">
							<md-field>
								<label>Client Phone *</label>
								<md-input type="text" v-model="client.phone"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-50">
							<md-field>
								<label>Gender *</label>
								<md-select placeholder="Gender *" v-model="client.gender">
									<md-option value="f">Female</md-option>
									<md-option value="m">Male</md-option>
									<md-option value="o">Other</md-option>
								</md-select>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-100">
							<md-field>
								<label>Client Note</label>
								<md-input type="text" v-model="client.note">
								</md-input>
							</md-field>
						</div>
					</div>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-50">
					<div class="md-layout-item md-small-size-100 md-size-100">
						<h3>Summary</h3>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100">
						<md-table>
							<md-table-row>
								<md-table-cell style="width: 50%;">Client Name</md-table-cell>
								<md-table-cell style="width: 5px">:</md-table-cell>
								<md-table-cell>
									<span v-if="String(client.name).length > 0">{{client.name}}</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>Client Khmer Name</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="String(client.name_khmer).length > 0">{{client.name_khmer}}</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>Gender</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="String(client.gender).length > 0 && client.gender == 'm'">Male</span>
									<span v-else-if="String(client.gender).length > 0 && client.gender == 'f'">Female</span>
									<span v-else-if="String(client.gender).length > 0 && client.gender == 'o'">Other</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>Client Phone</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="String(client.phone).length > 0">{{client.phone}}</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>Client Note</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="String(client.note).length > 0">{{client.note}}</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
						</md-table>
					</div>
				</div>
				<div class="md-layout-item md-size-100 text-right">
					<md-button class="md-raised md-primary" @click="postClient()">Create</md-button>
				</div>
			</div>

		</div>
	</div>

	<!-- <md-dialog-confirm :md-active.sync="deleteDialogActive" md-title="តើអ្នកពិតជាចង់លុបក្រុមហ៊ុននេះពិតមែនទេ ?"
			md-content="ព័ត៌មានក្រុមហ៊ុននឹងត្រូវបានលុបចេញពីបញ្ជីជារាងរហូត។" md-confirm-text="លុប" md-cancel-text="បោះបង់"
			@md-cancel="onCancel" @md-confirm="onDelete" /> -->
	</div>

</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			this.searchHandler();
		},

		data() {
			return {
				tabName: "first",
				loaded: false,
				deleteDialogActive: false,
				deleteSelected: '',
				search: {
					text: "",
					gender: ""
				},
				client: {
					valid: false,
					name: "",
					name_khmer: "",
					phone: "",
					gender: "",
					note: ""
				},
				loadMore: true,
				clientList: []

			}
		},
		methods: {
			postClient() {
				if(!this.checkValidation()) return false;
				this.$http.post(this.config.api + "/admin/client/post", {
					client: this.client
				}).then(data => {
					if (data.body.status == 'success') {
						this.tabName = 'first'
						this.$notification.notify({
							message: "Client was created successfully.",
							icon: 'done',
							type: 'success'
						});
						this.search.text = "";
						this.search.gender = "";
						this.searchHandler();
					}
					// this.loadMoreCompanyButton = true
					// this.memberList = data.body.data;
				})
			},
			searchHandler(more = false) {
				this.$http.post(this.config.api + "/admin/client/search", {
					text: this.search.text,
					gender: this.search.gender,
					offset: more ? this.clientList.length : 0
				}).then(data => {
					this.loaded = true;
					this.search.text = "";
					this.clientList = data.body.data;
				})
			},
			checkValidation() {
				if(String(this.client.name).length > 0 && String(this.name_khmer).length > 0 && String(this.client.phone).length > 0 && String(this.client.gender).length > 0) {
					return true;
				} else {
					this.$notification.notify({
							message: "Please fill in information.",
							icon: 'info',
							type: 'warning'
						});
					return false;
				}
			},
			clearAll() {
				this.search.text = "";
				this.search.gender = "";
				this.client = {
					valid: false,
					name: "",
					name_khmer: "",
					phone: "",
					gender: "",
					note: ""
				}
			}
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Clients/View.vue